import { formatArea } from "@nova/format"
import { OrthoFlight } from "@nova/protobuf"
import { selectWorkspaceAreaUnit } from "features/data-management/workspace/WorkspaceManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import { useMemo } from "react"

export const useInspectorPanelOrtho = (flight: OrthoFlight | undefined) => {
    const areaUnit = useAppSelector(selectWorkspaceAreaUnit)
    const formattedOrthoArea = useMemo(
        () =>
            flight?.job?.area ? formatArea({ value: flight.job.area, unit: areaUnit }) : undefined,
        [areaUnit, flight?.job?.area]
    )

    return { formattedOrthoArea }
}
